export default "__VITE_ASSET__1b4a1c3f__"